import { render, staticRenderFns } from "./resumeDetail.vue?vue&type=template&id=88c7065e&scoped=true"
import script from "./resumeDetail.vue?vue&type=script&lang=js"
export * from "./resumeDetail.vue?vue&type=script&lang=js"
import style0 from "./resumeDetail.vue?vue&type=style&index=0&id=88c7065e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7065e",
  null
  
)

export default component.exports